import { getVarsFromText } from '@nixi1/nx-channel-utils'

const addVars = () => {
  return {
    name: '{{VAR}}',
    tooltip: 'Añadir variable',
    exec: function (editor) {
      const numbersFromContent = getVarsFromText(editor.text)

      const index = numbersFromContent.length > 0 ? numbersFromContent.length + 1 : 1
      const newContent = `{{${index}}}`

      editor.selection.insertHTML(newContent)

      return false
    }
  }
}

export default function getControls() {
  return {
    add_vars: addVars()
  }
}